import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Brbanner from "../Page-section/branding/Brbanner";
import Brprocess from "../Page-section/branding/Brprocess";
import { useSEO } from "../hooks/useSEO";

function Branding() {
  useSEO({
    title: "Branding Agency in Noida | Logo Design & Creative Experts",
    description:
      "Branding Agency in Noida for Logo Design, Brand Strategy & Digital Branding. We help you attract more customers, maximize ROI , result-driven solutions.",
    canonical: "https://empowerweb.in/branding-agency-noida",
    ogTitle: "Branding Agency in Noida, top creative agency in Noida",
    ogDescription:
      "Build a strong brand identity with expert branding services. Logo design, brand strategy, and visual design.",
    keywords:
      "Branding Agency in Noida, top creative agency in Noida, logo and brand identity design",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <Brbanner />
        <Brprocess />
      </main>
      <Footer />
      
    </div>
  );
}

export default Branding;
